import { Fragment, FunctionalComponent, h } from '@stencil/core';

interface SearchProps {
}

export const Search: FunctionalComponent<SearchProps> = () => {
    const closeSearch = () => {
        document.querySelector(".e-header__center-wrap.search.show")?.classList.remove('show');
        document.querySelector(".e-header__center-wrap.default")?.classList.add('show');
    };

    const submitSearch = (event) => {
        event.preventDefault(); // Prevent the default form submission
        const searchInput = document.querySelector('input[name="globalSearch"]') as HTMLInputElement;
        const searchValue = searchInput?.value || '';
        const query = encodeURIComponent(`site: cradlepoint.com [${searchValue.trim()}]`);
        const url = `https://www.google.com/search?q=${query}`;
        window.open(url, '_blank'); // Open the new tab with the search URL
        closeSearch(); // Close the search container after submission
    };

    return (
        <Fragment>
            {/* search component */}
            <div class="e-header__center-wrap search">
                <form id="globalSearchForm" class="isSearching" onSubmit={submitSearch} >
                    <div class="input-container">
                        <i class="search__icon icon icon-search"></i>
                        <input name="globalSearch" class="search-input" type="text" />
                    </div>
                    <button type="button" class="search-cancel" onClick={closeSearch}>Cancel</button>
                </form>
            </div>
        </Fragment>
    );
};